define('tracks/track-store',["require", "exports", "../notifications", "../util/http", "./track"], function (require, exports, notifications, http_1, track) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getExitTracks = exports.getUserTracks = exports.getTrackData = void 0;
    // Track data cache
    var trackData = {};
    // User track listing cache
    var userTracks = {};
    /**
     * Fetch data for a track.
     * Uses a local cache, so calling multiple times is safeish.
     */
    function getTrackData(trackId) {
        if (!trackData[trackId]) {
            // Not cached, start a fetch
            trackData[trackId] = (0, http_1.getJson)("/tracks/" + trackId + "/baseline-track.json")
                .then(track.fromJson) // Map JSON into Track class
                .catch(function (e) {
                notifications.error("Failed to fetch track data: " + e);
                throw e;
            });
            return trackData[trackId];
        }
        else {
            return trackData[trackId];
        }
    }
    exports.getTrackData = getTrackData;
    /**
     * Fetch a list of tracks for a user
     */
    function getUserTracks(userId) {
        if (!userTracks[userId]) {
            // Not cached, start a fetch
            userTracks[userId] = (0, http_1.getJson)("/users/" + userId + "/tracks.json")
                .then(function (tracksJson) { return tracksJson.data; });
            return userTracks[userId];
        }
        else {
            return userTracks[userId];
        }
    }
    exports.getUserTracks = getUserTracks;
    /**
     * Fetch a list of tracks for a user
     */
    function getExitTracks(lat, lng) {
        return (0, http_1.getJson)("/exits/" + lat + "/" + lng + "/tracks.json")
            .then(function (tracksJson) { return tracksJson.data; });
    }
    exports.getExitTracks = getExitTracks;
});
//# sourceMappingURL=/assets/javascripts/tracks/track-store.js.map;
